import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Register from '@/components/Register'
import ForgetPwd from '@/components/ForgetPwd'
import Container from '@/components/common/Container'
// 管理员
import DepartmentManage from '@/components/admin/operate/DepartmentManage'
import SchoolManage from '@/components/admin/operate/SchoolManage'
import YearManage from '@/components/admin/operate/YearManage'
import ConfigManage from '@/components/admin/ConfigManage'
import ApplyManage from '@/components/admin/apply/ApplyManage'
import ViewPrimaryTarget from '@/components/admin/apply/ViewPrimaryTarget'
import ViewHigherTarget from '@/components/admin/apply/ViewHigherTarget'
import ReportTemplate from '@/components/admin/apply/ReportTemplate'
// 市/区管理员
import PeopleManage from '@/components/district-admin/people/PeopleManage'
import DistrictDepartmentManage from '@/components/district-admin/people/DepartmentManage'
import DistrictPermissionManage from '@/components/district-admin/permission/PermissionManage'
import DistrictApplyManage from '@/components/district-admin/apply/ApplyManage'
import DistrictViewPrimaryTarget from '@/components/district-admin/apply/ViewPrimaryTarget'
import DistrictViewHigherTarget from '@/components/district-admin/apply/ViewHigherTarget'
// 校级管理员
import TeacherManage from '@/components/school-admin/affair/TeacherManage'
import StudentManage from '@/components/school-admin/affair/StudentManage'
import ClassManage from '@/components/school-admin/affair/ClassManage'
import SubjectManage from '@/components/school-admin/affair/SubjectManage'
import SealManage from '@/components/school-admin/affair/SealManage'
import OuterInfoManage from '@/components/school-admin/affair/OuterInfoManage'
import PermissionManage from '@/components/school-admin/permission/PermissionManage'
import SchoolApplyManage from '@/components/school-admin/apply/ApplyManage'
import SchoolViewPrimaryTarget from '@/components/school-admin/apply/ViewPrimaryTarget'
import SchoolViewHigherTarget from '@/components/school-admin/apply/ViewHigherTarget'
// 机构管理员、学校管理员-修改密码
import ResetPassword from '@/components/common/change-password/Index'

// 大屏幕
import ScreenHome from '@/components/big-screen/Index'
import DistrictAnalysis from '@/components/big-screen/DistrictAnalysis'
import SchoolAnalysis from '@/components/big-screen/SchoolAnalysis'

// 大屏幕跳转
import RedirectHengshui from '@/components/RedirectHengshui'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: { requireAuth: false },
      component: Login,
      hidden: true
    },
    {
      path: '/login',
      name: 'Login',
      meta: { requireAuth: false },
      component: Login,
      hidden: true
    },
    {
      path: '/register',
      name: 'Register',
      meta: { requireAuth: false },
      component: Register,
      hidden: true
    },
    {
      path: '/password',
      name: 'ForgetPwd',
      meta: { requireAuth: false },
      component: ForgetPwd,
      hidden: true
    },
    {
      path: '/admin',
      component: Container,
      name: 'AdminContainer',
      meta: { requireAuth: true },
      children: [
        {
          path: 'operate/department-manage',
          name: 'AdminDepartmentManage',
          component: DepartmentManage
        },
        {
          path: 'operate/operation-management',
          name: 'AdminOperationManage',
          component: () =>
            import('@/components/admin/operate/OperationManagement')
        },
        {
          path: 'operate/school-manage',
          name: 'AdminSchoolManage',
          component: SchoolManage
        },
        {
          path: 'operate/year-manage',
          name: 'AdminYearManage',
          component: YearManage
        },
        { path: 'apply', name: 'AdminApplyManage', component: ApplyManage },
        {
          path: 'apply/primary-target/:id',
          name: 'AdminViewPrimaryTarget',
          props: true,
          component: ViewPrimaryTarget
        },
        {
          path: 'apply/higher-target/:id',
          name: 'AdminViewHigherTarget',
          props: true,
          component: ViewHigherTarget
        },
        {
          path: 'apply/view-template',
          name: 'AdminViewTemplate',
          component: ReportTemplate
        },
        {
          path: 'config/basic-config',
          name: 'AdminBasicConfigModule',
          component: ConfigManage
        }
      ]
    },
    {
      path: '/district-admin',
      component: Container,
      name: 'DistrictAdminContainer',
      meta: { requireAuth: true },
      children: [
        {
          path: 'people/people-manage',
          name: 'PeopleManage',
          component: PeopleManage
        },
        {
          path: 'people/department-manage',
          name: 'DistrictDepartmentManage',
          component: DistrictDepartmentManage
        },
        {
          path: 'permission/permission-manage',
          name: 'DistrictPermissionManage',
          component: DistrictPermissionManage
        },
        {
          path: 'apply',
          name: 'DistrictApply',
          component: DistrictApplyManage
        },
        {
          path: 'apply/primary-target/:id?',
          name: 'DistrictViewPrimaryTarget',
          props: true,
          component: DistrictViewPrimaryTarget
        },
        {
          path: 'apply/higher-target/:id?',
          name: 'DistrictViewHigherTarget',
          props: true,
          component: DistrictViewHigherTarget
        },
        {
          path: 'apply/view-template',
          name: 'DistrictViewTemplate',
          component: ReportTemplate
        }
      ]
    },
    {
      path: '/school-admin',
      component: Container,
      name: 'SchoolAdminContainer',
      meta: { requireAuth: true },
      children: [
        {
          path: 'affair/teacher-manage',
          name: 'TeacherManage',
          component: TeacherManage
        },
        {
          path: 'affair/student-manage',
          name: 'StudentManage',
          component: StudentManage
        },
        {
          path: 'affair/class-manage',
          name: 'ClassManage',
          component: ClassManage
        },
        {
          path: 'affair/subject-manage',
          name: 'SubjectManage',
          component: SubjectManage
        },
        {
          path: 'affair/seal-manage',
          name: 'SealManage',
          component: SealManage
        },
        {
          path: 'affair/outer-info-manage',
          name: 'OuterInfoManage',
          component: OuterInfoManage
        },
        {
          path: 'permission/permission-manage',
          name: 'PermissionManage',
          component: PermissionManage
        },
        { path: 'apply', name: 'SchoolApply', component: SchoolApplyManage },
        {
          path: 'apply/primary-target/:id?',
          name: 'SchoolViewPrimaryTarget',
          props: true,
          component: SchoolViewPrimaryTarget
        },
        {
          path: 'apply/higher-target/:id?',
          name: 'SchoolViewHigherTarget',
          props: true,
          component: SchoolViewHigherTarget
        },
        {
          path: 'apply/view-template',
          name: 'SchoolViewTemplate',
          component: ReportTemplate
        }
      ]
    },
    // 应用服务教师用户
    {
      path: '/teacher-user',
      name: 'TeacherUser',
      component: Container,
      children: [
        {
          // 教师用户首页
          path: '/teacher-home',
          name: 'TeacherHome',
          component: () => import('@/components/teacher-user/teacher-home')
        },
        {
          // 教师用户首页
          path: '/teacher-home/:second',
          name: 'TeacherHome',
          component: () => import('@/components/teacher-user/teacher-home')
        },
        {
          // 综合评价(年级)
          path: '/teacher-grade-judge',
          name: 'TeacherGradeJudge',
          component: () =>
            import(
              '@/components/teacher-user/teacher-judge-manage/teacher-grade-judge'
            )
        },
        {
          // 综合评价(班级)
          path: '/teacher-class-judge',
          name: 'TeacherClassJudge',
          component: () =>
            import(
              '@/components/teacher-user/teacher-judge-manage/teacher-class-judge'
            )
        },
        {
          // 评价档案
          path: '/teacher-judge-file',
          name: 'TeacherJudgeFile',
          component: () =>
            import(
              '@/components/teacher-user/teacher-judge-file/teacher-judge-file'
            )
        },
        // 素质报告（年级）
        {
          path: '/teacher-grade-quality-report',
          name: 'TeacherGradeQualityReport',
          component: () =>
            import(
              '@/components/teacher-user/teacher-quality-report/teacher-grade-quality-report'
            )
        },
        // 素质报告（班级）
        {
          path: '/teacher-class-quality-report',
          name: 'TeacherClassQualityReport',
          component: () =>
            import(
              '@/components/teacher-user/teacher-quality-report/teacher-class-quality-report'
            )
        },
        {
          // 个性记录年级
          path: '/teacher-grade-persona-record',
          name: 'TeacherGradePersonaRecord',
          component: () =>
            import(
              '@/components/teacher-user/teacher-persona-record/teacher-grade-persona-record'
            )
        },
        {
          // 个性记录班级
          path: '/teacher-class-persona-record',
          name: 'TeacherClassPersonaRecord',
          component: () =>
            import(
              '@/components/teacher-user/teacher-persona-record/teacher-class-persona-record'
            )
        },
        {
          // 个人中心
          path: '/personal-center',
          name: 'PersonalCenter',
          component: () => import('@/components/teacher-user/personal-center')
        }
      ]
    },
    // 应用服务市区用户
    {
      path: '/district-user',
      name: 'districtUser',
      component: Container,
      children: [
        {
          // 首页
          path: '/district-home',
          name: 'DistrictHome',
          component: () =>
            import(
              '@/components/district-user/district-judge/components/teacher-class-judge'
            )
        },
        {
          // 综合评价
          path: '/district-judge',
          name: 'DistrictJudge',
          component: () =>
            import(
              '@/components/district-user/district-judge/components/teacher-class-judge'
            )
        },
        {
          // 评价状态
          path: '/judge-status',
          name: 'DistrictJudgeStatus',
          component: () =>
            import(
              '@/components/district-user/district-judge/components/teacher-class-judge-status'
            )
        },
        {
          // 评价公示进度监控
          path: '/district-judge/district-grade-judge',
          name: 'DistrictGradeJudge',
          component: () =>
            import(
              '@/components/district-user/district-judge/components/teacher-grade-judge/teacher-judge'
            )
        },
        {
          // 评价公示进度监控班级详情
          path: '/district-judge/district-judge-details',
          name: 'DistrictJudgeDetails',
          component: () =>
            import(
              '@/components/district-user/district-judge/components/teacher-grade-judge/teacher-judge-details'
            )
        },
        {
          // 素质报告
          path: '/district-quality-report',
          name: 'DistrictQualityReport',
          component: () =>
            import('@/components/district-user/district-quality-report')
        },
        // 机构管理员、学校管理员-修改密码
        {
          path: '/reset-password',
          name: 'ResetPassword',
          component: ResetPassword
        }
      ]
    },
    // 应用服务学生用户
    {
      path: '/student-user',
      name: 'studentUser',
      component: Container,
      children: [
        {
          // 首页
          path: '/student-home',
          name: 'StudentHome',
          component: () => import('@/components/student-user/student-home')
        },
        {
          // 首页
          path: '/student-home/:second',
          name: 'StudentHome',
          component: () => import('@/components/student-user/student-home')
        },
        {
          // 综合评价
          path: '/student-judge-module',
          name: 'StudentJudgeModule',
          component: () =>
            import('@/components/student-user/student-judge-module')
        },
        {
          // 素质报告
          path: '/student-report-module',
          name: 'StudentReportModule',
          component: () =>
            import('@/components/student-user/student-report-module')
        },
        {
          // 个性记录
          path: '/student-persona-record',
          name: 'StudentPersonaRecord',
          component: () =>
            import('@/components/student-user/student-persona-record')
        },
        {
          // 体质健康
          path: '/student-physical-check',
          name: 'StudentPhysicalCheck',
          component: () =>
            import('@/components/student-user/student-physical-check')
        }
      ]
    },
    // 大屏幕
    {
      path: '/screen-home',
      name: 'ScreenHome',
      meta: { requireAuth: false, title: '衡水市中小学基本情况统计' },
      component: ScreenHome,
      hidden: true
    },
    {
      path: '/district-analysis',
      name: 'DistrictAnalysis',
      meta: { requireAuth: false, title: '衡水市中小学基本情况统计' },
      component: DistrictAnalysis,
      hidden: true
    },
    {
      path: '/school-analysis',
      name: 'SchoolAnalysis',
      meta: { requireAuth: false, title: '衡水市中小学基本情况统计' },
      component: SchoolAnalysis,
      hidden: true
    },
    // 大屏跳转
    {
      path: '/redirect-hengshui',
      name: 'RedirectHengshui',
      meta: { requireAuth: false, title: '衡水市中小学基本情况统计' },
      component: RedirectHengshui,
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js